import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Box, Collapse, IconButton, LinearProgress,
    Paper, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Tooltip,
} from '@material-ui/core';
import axios from 'axios';
import qs from 'qs';
import moment from 'moment';
import {useHistory} from "react-router-dom";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import CreateIcon from '@material-ui/icons/Create';
import {ErrorGeneral, llamaApiCargaToken} from '../../funciones/ClienteAxios';
import NvoCombustible from './NvoEditCombustible';

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: window.innerHeight - 170,
        minHeight: 280,
        minWidth: '100%',
    },
    container2: {
        maxHeight: 550,
    },
    tableRow: {
        "&$selected, &$selected:hover": {
            backgroundColor: process.env.REACT_APP_COLOR
        }
    },
    tableCell: {
        "$selected &": {
            color: "white"
        }
    },
    hover: {},
    selected: {}
});

export default function TablaCombustible({   regisMaquinaria,fSeleccionadas,buscar   }) {
    const classes = useStyles();
    let history = useHistory();
    const idusu = localStorage.getItem('UsuId');
    const source = axios.CancelToken.source();
    const [registro, setRegistro] = useState([]);
 
    const [open, setOpen] = useState(false);
    const [espera, setEspera] = useState(false);
    const [ordenSelecc, setOrdenSelecc] = useState(0);
    const [seleccionadoEdit, setSeleccionadoEdit] = useState([]);
    const [modalAbierto, setModalAbierto] = useState(false);
    const [datos, guardarDatos] = useState([])
    const [sinDatos, guardarSinDatos] = useState(true)    
    const [modNvo, setModNvo] = useState(false)    

    useEffect(() => {                  
        
        getListTabla(regisMaquinaria.Id)
        return () => {
            source.cancel();
        }
    }, [regisMaquinaria, buscar]);

      const getListTabla = (Maquinaria) => {        
        const fInicio=moment(fSeleccionadas.inicio).format("YYYY-MM-DD")
        const fFinal=moment(fSeleccionadas.final).format("YYYY-MM-DD")
        const data = qs.stringify({
            Usuario:idusu,
            Maquinaria: Maquinaria,
            FIni:`${fInicio}T00:00:00`,
            FFin:`${fFinal}T23:59:59`,
            ip:"172.2.2.2",
            idDispositivo: '89y7gttvjhj98h'
        });
        const url = "/maquinaria/combustible/bitacora/fecha";

        function respuestaListTabla(aux) {
            if (aux[0].BtId !== -1 && aux[0].BtId !== "-1" ) {
                guardarDatos(aux)                                    
                
            } 
            else{
                guardarDatos([])    
            }
        }

        llamaApiCargaToken(data, url, respuestaListTabla, ErrorGeneral, setEspera, history, source);
    };   

 
    const seleccionado = (auxReg) => {
        setRegistro(auxReg)       
    }

    function editarFall(auxFalla) {
        setSeleccionadoEdit(auxFalla)

        setModalAbierto(true)
    }

    function verMas(auxId) {

        if (auxId === ordenSelecc) {
            setOpen(!open)
        } else {
            setOpen(true)
        }
        setOrdenSelecc(auxId)
    }

    const minuscula=(cadena)=>{
        let nvo=""
        nvo = cadena.substring(0,1) + cadena.substring(1,cadena.length).toLowerCase()
        return nvo}

    function Row(props) {
        const {row} = props;
        //console.log("nuevo");
        
        return (       
        <TableRow onClick={() => { seleccionado(row); }}
            className={classes.tableRow} selected={registro?.BtId === row.BtId}
            classes={{hover: classes.hover, selected: classes.selected}}
        >
        
            {/*   <TableCell align="center" padding={'none'} style={{width: 30 + 'px'}}>
                <Tooltip title={open && ordenSelecc === row.Id ? 'Ver menos' : 'Ver más'}>
                    <IconButton color="primary" aria-label="expand row" size="small"
                        onClick={() => verMas(row.Id)}>
                        {open && ordenSelecc === row.Id 
                        ? (registro?.Id === row.Id ?
                            <KeyboardArrowUpIcon style={{color: 'white'}}/> 
                            :    <KeyboardArrowUpIcon/>
                        ) 
                        :  ( registro?.Id === row.Id ? 
                            <KeyboardArrowDownIcon style={{color: 'white'}}/> 
                            :   <KeyboardArrowDownIcon/>)}
                    </IconButton>
                </Tooltip>
            </TableCell> */}
        
            <TableCell className={classes.tableCell} align="center" padding={'none'} style={{width: 150 + 'px'}}>
                {row.Fch}
            </TableCell>
            <TableCell className={classes.tableCell} align="right" style={{   width: 70 + 'px'}}
                padding={'none'}>{row.Cantidad}
            </TableCell> 
            <TableCell className={classes.tableCell} align="center" style={{   width: 50 + 'px'}}
                padding={'none'}>{row.Unidad}
            </TableCell> 
            <TableCell className={classes.tableCell} align="left" style={{   paddingLeft:"8px"}}
                padding={'none'}>{row.Nota}
            </TableCell>
        </TableRow>               
        );
    }

    function tablaCompleta(auxlista) {
        const cuenta=auxlista.length!==0 ? auxlista.filter((regis)=>regis.RefId===0):[""]
        return (
        <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
            <TableHead>
                <TableRow>
                    <TableCell align="center" padding='none' >     
                     
                        <IconButton onClick={()=>setModNvo(true)}>
                            <Tooltip title="Nuevo Registro">
                                <AddCircleOutlineIcon/>
                            </Tooltip>
                        </IconButton> {`  Fecha`}</TableCell>
                {/*     <TableCell align="center" padding='none'>Maquina</TableCell> */}
                    <TableCell align="center" padding='none'>Cantidad</TableCell>
                    <TableCell align="center" padding='none'>Unidad</TableCell>
                    <TableCell align="center" padding='none'>Descripción </TableCell>                    
                      
                    
                </TableRow>
            </TableHead>
            <TableBody>
                {auxlista.length !== 0 ? (auxlista.map((row) => (
                    <Row key={row.Id} row={row}/>
                    
                ))) : null}
            </TableBody>
        </Table>
        </TableContainer>
        )
    }

    const tablaSinDatos = () => {
        return (
        <TableContainer className={classes.container2}>
            <Table stickyHeader aria-label="sticky table">
                <TableHead>
                    <TableRow>
                        <TableCell align="center" padding='none'>
                            <IconButton onClick={()=>setModNvo(true)}>
                                <Tooltip title="Nuevo Registro">
                                    <AddCircleOutlineIcon/>
                                </Tooltip>
                            </IconButton>  
                        </TableCell>
                        <TableCell align="left" padding='none'>Fecha</TableCell>
                      
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow  className={classes.tableRow} >
                        
                        <TableCell className={classes.tableCell} align="left" padding='none'>Sin</TableCell>
                        <TableCell className={classes.tableCell} align="left" padding='none'>Registros</TableCell>

                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
        )
    }

    const tablaSinResultados = () => {
        return (
        <TableContainer className={classes.container2}>
        <Table stickyHeader aria-label="sticky table">
            <TableHead>
                <TableRow>
                    <TableCell align="center">  </TableCell>
                    <TableCell align="left">Fecha</TableCell>
                    <TableCell align="left">Estatus</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow className={classes.tableRow} >
                   
                    <TableCell className={classes.tableCell} align="left">Sin</TableCell>
                    <TableCell className={classes.tableCell} align="left">coincidencias</TableCell>
                </TableRow>
            </TableBody>
        </Table>
        </TableContainer>
        )
    }
    
    const modNvoBit = modNvo ?<NvoCombustible modalAbierto={modNvo} setModalAbierto={setModNvo} 
                                titulo={"Nuevo Registro"} regisMaquinaria={regisMaquinaria} funcionActuliza={getListTabla} /> :null
    const contenido = datos.length !== 0 && datos[0].Id !== "-1" &&datos[0].Id !== -1 ? tablaCompleta(datos) : tablaSinDatos()
    const tabla = espera ? (<Box style={{paddingTop:"5rem"}} ><LinearProgress/> </Box>) : (contenido)
 
    return (
    <Paper className={classes.root}>
        {tabla}
        {modNvoBit}
    </Paper>
    );
}